import { useState } from "react";
import { PartyPopper } from "lucide-react";
import { api, errText } from "../lib/api";
import { useLanguage } from "../context/LanguageContext";
import { Switch } from "./ui/switch";
import { toast } from "sonner";

export function SeasonalEmailPref({ user }) {
  const { t } = useLanguage();
  const [on, setOn] = useState(user?.seasonal_emails !== false);
  const [saving, setSaving] = useState(false);
  const toggle = async (v) => {
    setOn(v); setSaving(true);
    try { await api.put("/auth/me/preferences", { seasonal_emails: v }); toast.success(v ? t("se_on") : t("se_off")); }
    catch (e) { setOn(!v); toast.error(errText(e)); }
    finally { setSaving(false); }
  };
  return (
    <div className="max-w-xl bg-white rounded-2xl border border-slate-200/80 p-6 flex items-start gap-4" data-testid="seasonal-email-pref">
      <span className="h-10 w-10 rounded-xl bg-[#FFF4F0] flex items-center justify-center shrink-0"><PartyPopper size={20} className="text-[#F5551E]" /></span>
      <div className="flex-1">
        <p className="font-display font-bold text-[#12234A]">{t("se_title")}</p>
        <p className="text-sm text-slate-500 mt-0.5">{t("se_desc")}</p>
      </div>
      <Switch checked={on} disabled={saving} onCheckedChange={toggle} data-testid="seasonal-email-toggle" />
    </div>
  );
}
